// src/context/ThemeContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  // Définir darkMode à true par défaut
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    // Vérifier si l'utilisateur a déjà une préférence
    // Si aucune préférence n'est trouvée (null), utiliser le mode sombre
    const storedPreference = localStorage.getItem('darkMode');
    const isDark = storedPreference === null ? true : storedPreference === 'true';
    
    setDarkMode(isDark);
    
    // Appliquer la classe dark au document
    if (isDark) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, []);

  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    localStorage.setItem('darkMode', newDarkMode);
    
    if (newDarkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  return (
    <ThemeContext.Provider value={{ darkMode, toggleDarkMode }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => useContext(ThemeContext);

export default ThemeContext;